/**
 * PATH: packages/email-hub/src/feature/reader-header/command/moreMenuDismiss.ts
 * FILE_ID: EMAILHUB-READERHEADER-MORE-MENU-DISMISS-001
 * PURPOSE: I→O rules for closing the reader More menu and keeping zoom
 *          actions on-screen so the operator can step the body scale.
 * WHY: The in-tree fixed backdrop was clipped by Job Hub overflow-hidden,
 *      so outside clicks never arrived and zoom looked dead.
 * FLOW:
 *   ┌────────────┐   ┌──────────────┐   ┌─────────────┐
 *   │ pointer /  │ → │ inside menu  │ → │ dismiss?    │
 *   │ action id  │   │ or trigger?  │   │ keep open?  │
 *   └────────────┘   └──────────────┘   └─────────────┘
 */

export function shouldDismissMoreMenuOnPointer(
  target: EventTarget | null,
  menu: Node | null,
  trigger: Node | null,
): boolean {
  if (!(target instanceof Node)) return true
  if (menu?.contains(target)) return false
  if (trigger?.contains(target)) return false
  return true
}

export function shouldKeepMoreMenuOpenAfterAction(actionId: string): boolean {
  return actionId === 'zoom_in' || actionId === 'zoom_out' || actionId === 'zoom_reset'
}
